import axios from '@/config/axiosConfig';
import { CREATE_BROKER, GET_BROKERS, BROKER_REQUEST, DELETE_BROKER, UPDATE_BROKER, BROKER_REQUEST_FAILURE, GET_BROKERS_PAGE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getBrokersWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal, commonMaster) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BROKER_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, company_id: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
      };
    if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
      if (commonMaster !== undefined) {
        params = {
          ...params,
          companyId: commonMaster ? undefined : auth.company?.id
        };
      }
      return axios.get("/broker/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BROKERS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBrokers = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BROKER_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
              }
            return axios.get('/broker/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BROKERS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createBroker = (data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { broker } = getState();
            dispatch({ type: BROKER_REQUEST });

            return axios.post('/broker/add', data,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then( async (response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_BROKER, payload: response.data });
                        // Re-fetch the current page to get updated data
                        await dispatch(getBrokersWithPagination(
                            broker.page || 1,           // current page
                            broker.pageSize || 10,      // current page size
                            undefined,                  // include
                            broker.search || '',        // current search
                            undefined,                  // searchCols
                            broker.where || {},         // current filters
                            true                        // addTotal
                        ));
                        dispatch(addMasterInOption('brokers', response.data));
                    } else {
                        dispatch({ type: BROKER_REQUEST_FAILURE, error: 'Broker create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBroker = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            const { broker } = getState();
            dispatch({ type: BROKER_REQUEST });
            return axios.put('/broker/update', { id, data }, { params: { userId: auth.user?.id }}).then( async (response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_BROKER, payload: { id, data: response.data } });
                    // Re-fetch the current page to get updated data
                    await dispatch(getBrokersWithPagination(
                        broker.page || 1,           // current page
                        broker.pageSize || 10,      // current page size
                        undefined,                  // include
                        broker.search || '',        // current search
                        undefined,                  // searchCols
                        broker.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('brokers', id, response.data));
                } else {
                    dispatch({ type: BROKER_REQUEST_FAILURE, error: 'Broker update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteBroker = (id) => {
    return async (dispatch, getState) => {
        try {
            const { broker } = getState();
            dispatch({ type: BROKER_REQUEST });
            return axios.delete(`/broker/delete/${id}`).then( async (response) => {
                if (response.data) {
                    dispatch({ type: DELETE_BROKER, id: id });
                    // Re-fetch the current page to get updated data
                    await dispatch(getBrokersWithPagination(
                        broker.page || 1,           // current page
                        broker.pageSize || 10,      // current page size
                        undefined,                  // include
                        broker.search || '',        // current search
                        undefined,                  // searchCols
                        broker.where || {},         // current filters
                        true                        // addTotal
                    ));
                    dispatch(updateMasterInOption('brokers', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BROKER_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};